<template>
    <div class="diet" :class="{ 'is-active': isActive }" @click="clicked">
        {{ title }}
    </div>
</template>

<script>
import { wrapFunction } from '../js/utils.js';

export default {
    name: 'Diet',
    computed: wrapFunction(`
        title
        name
        isActive
    `),
    watch: {
        isActive(val) {
            if (val === true) {
                this.$emit('select', this.data);
            }
        }
    },
    props: {
        data: Object
    },
    methods: {
        clicked() {
            this.data.isActive = true;
        }
    }
}
</script>

<style lang="scss">
@import '../scss/config';

.diet {
    $parent: &;
    @include font-semibold();
    flex-shrink: 1;
    white-space: nowrap;
    color: color(middleground);
    font-size: size(font-tiny);
    margin-bottom: size(medium);
    cursor: pointer;

    padding-right: size(smaller);
    padding-bottom: size(smaller);
    border-bottom: size(line) solid currentColor;

    &.is-active {
        color: color(accent);
    }
}

</style>
